export default __webpack_public_path__ + "static/media/pic7.5a00ab1e.jpg";